export const messages = {
  en: {
    serviceRegisterManage: {
      queryCondition: 'Query Conditions',
      selectAppName: 'Please select application name',
      inputServiceName: 'Please input service name',
      inputServiceCode: 'Please input service code',
      select: 'Select',
      query: 'Query',
      reset: 'Reset',
      serviceBinding: 'Service Binding',
      bindingId: 'Binding ID',
      appId: 'Application ID',
      appName: 'Application Name',
      serviceId: 'Service ID',
      serviceName: 'Service Name',
      serviceCode: 'Service Code',
      orderType: 'Order Type',
      invokeUrl: 'Invoke URL',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    chooseApp: {
      selectApp: 'Select Application',
      inputAppName: 'Input application name',
      query: 'Query',
      appId: 'Application ID',
      appName: 'Application Name',
      operation: 'Operation',
      select: 'Select'
    },
    editServiceRegister: {
      editServiceBinding: 'Edit Service Binding',
      appId: 'Application ID',
      requiredAppId: 'Required, please input application ID',
      serviceId: 'Service ID',
      requiredServiceId: 'Required, please input service ID',
      orderType: 'Order Type',
      requiredOrderType: 'Required, please select order type',
      query: 'Query',
      businessAcceptance: 'Business Acceptance',
      invokeTimes: 'Invoke Times',
      requiredInvokeTimes: 'Required, please input invoke times',
      invokeMethod: 'Invoke Method',
      requiredInvokeMethod: 'Required, please select invoke method',
      syncMethod: 'Sync Method',
      asyncMethod: 'Async Method',
      cancel: 'Cancel',
      save: 'Save',
      updateSuccess: 'Update successfully',
      appIdRequired: 'Application ID is required',
      serviceIdRequired: 'Service ID is required',
      orderTypeRequired: 'Order type is required',
      invokeTimesRequired: 'Invoke times is required',
      invokeMethodRequired: 'Invoke method is required'
    },
    deleteServiceRegister: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteServiceBinding: 'Confirm to delete service binding',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    serviceRegisterManage: {
      queryCondition: '查询条件',
      selectAppName: '请选择应用名称',
      inputServiceName: '请输入服务名称',
      inputServiceCode: '请输入服务编码',
      select: '选择',
      query: '查询',
      reset: '重置',
      serviceBinding: '服务绑定',
      bindingId: '绑定ID',
      appId: '应用ID',
      appName: '应用名称',
      serviceId: '服务ID',
      serviceName: '服务名称',
      serviceCode: '服务编码',
      orderType: '订单类型',
      invokeUrl: '调用地址',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    chooseApp: {
      selectApp: '选择应用',
      inputAppName: '输入应用名称',
      query: '查询',
      appId: '应用ID',
      appName: '应用名称',
      operation: '操作',
      select: '选择'
    },
    editServiceRegister: {
      editServiceBinding: '修改服务绑定',
      appId: '应用ID',
      requiredAppId: '必填，请填写应用ID',
      serviceId: '服务ID',
      requiredServiceId: '必填，请填写服务ID',
      orderType: '订单类型',
      requiredOrderType: '必填，请选择订单类型',
      query: '查询',
      businessAcceptance: '业务受理',
      invokeTimes: '调用次数',
      requiredInvokeTimes: '必填，请填写调用次数',
      invokeMethod: '调用方式',
      requiredInvokeMethod: '必填，请选择调用方式',
      syncMethod: '同步方式',
      asyncMethod: '异步方式',
      cancel: '取消',
      save: '保存',
      updateSuccess: '修改成功',
      appIdRequired: '应用ID不能为空',
      serviceIdRequired: '服务ID不能为空',
      orderTypeRequired: '订单类型不能为空',
      invokeTimesRequired: '调用次数不能为空',
      invokeMethodRequired: '调用方式不能为空'
    },
    deleteServiceRegister: {
      confirmOperation: '请确认您的操作',
      confirmDeleteServiceBinding: '确定删除服务绑定',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功'
    }
  }
}